import React from "react";
import { usePlaybackRate } from "../../../context/PlaybackRate";
import { SettingsMenuItem } from "./SettingsMenuItem";
import { SettingsMenuSection } from "./SettingsMenuSection";
import { SettingsMenuList } from "./SettingsMenuList";
import { SettingsMenuTitle } from "./SettingsMenuTitle";

export const PlaybackRateMenu = () => {
  const [playbackRate, setPlaybackRate] = usePlaybackRate();

  return (
    <SettingsMenuSection
      title={
        <SettingsMenuTitle data-play-rate-title icon="icon-PlaySpeed">
          Play rate
        </SettingsMenuTitle>
      }
      data-speed-menu
    >
      <SettingsMenuList>
        {[
          [0.5, "slower"],
          [1, "normal"],
          [1.25, "fast"],
          [1.5, "faster"],
          [2, "fastest"],
        ].map(([rate, label]) => (
          <SettingsMenuItem
            key={rate}
            icon={rate === playbackRate && "x"}
            active={rate === playbackRate}
            onClick={() => {
              setPlaybackRate(rate);
            }}
            role="button"
            tabIndex="0"
          >
            <span data-rate-value>{rate}</span> -{" "}
            <span data-rate-label>{label}</span>
          </SettingsMenuItem>
        ))}
      </SettingsMenuList>
    </SettingsMenuSection>
  );
};
